export default __webpack_public_path__ + "static/media/4a1f75c9f885653478688caad40d4e204aef0f0cf3cf172180f60dea3b1d2f40.8e8cde75.svg";